module.exports = __webpack_public_path__ + "static/img/AM.634b83e5.png";